import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';
import { fonts } from '@cobliteam/base-components/src/styles/fonts';

export const stepByStepEmptyState = css`
  display: flex;
  flex-direction: column;
  width: 940px;
  align-self: center;
  margin: 20px 20px 0px;
  background-color: ${colors.gray.lightest};
  border-radius: 5px;
  overflow: hidden;
`;

export const steps = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  position: relative;
  counter-reset: stepCounter;

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;

    > img {
      display: flex;
      height: 280px;
      z-index: 1;
      filter: drop-shadow(-5px 6px 30px rgba(7, 7, 78, 0.2));
      border-radius: 7px;
    }

    > span {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      width: 250px;
      margin-top: 40px;

      :before {
        content: counter(stepCounter);
        counter-increment: stepCounter;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${colors.white};
        width: 24px;
        height: 24px;
        border-radius: 50%;
        font-weight: bold;
        font-size: ${fonts.size.smallest};
        color: ${colors.gray.default};
        margin-bottom: 10px;
      }
    }
  }
`;

export const nextStep = css`
  position: absolute;
  transform: translate(190px, -65%) rotate(-1.8deg);

  :nth-child(4) {
    transform: translate(470px, -45%) matrix(0.99, -0.17, -0.17, -0.99, 0, 0);
  }
`;

export const addChecklist = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 35px 0;
  background-color: ${colors.gray.lightest};
  mix-blend-mode: multiply;

  > button {
    margin-left: 30px;
    min-width: 160px;
    white-space: nowrap;
  }
`;
